// extracted by mini-css-extract-plugin
module.exports = {"Hours":"Hours-module--Hours--1_oDS","storeHours":"Hours-module--storeHours--3z3v9","today":"Hours-module--today--2VWuO"};